import { EnvironmentService } from "@gtmhub/env";
import { MetricTargetOperator } from "@gtmhub/okrs/metrics";
import { IHttpService, IPromise } from "angular";

export interface IMetricPrediction {
  predId: string;
  targetOperator: MetricTargetOperator;
  target?: number;
  format?: { prefix: string; suffix: string; fractionSize: number };
  operatorModelVersion: string;
  targetUnitModelVersion: string;
  initialValue?: number;
  metadata: Map<string, string>;
}

export interface IMetricFieldsChoice {
  metricId: string;
  predId: string;
  title: string;
  operatorSelected: string;
  operatorPredicted: string;
  targetSelected: number;
  targetPredicted: number;
  unitSelected: string | number;
  unitPredicted: string | number;
  unitTypeSelected: string;
  unitTypePredicted: string;
  operatorModelVersion: string;
  targetUnitModelVersion: string;
  initialValuePredicted: number;
  initialValueSelected: number;
  metadata: Map<string, string>;
}

export class AutoFieldsService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: IHttpService, private env: EnvironmentService) {}

  public getPredictionFromMetric(title: string): IPromise<IMetricPrediction> {
    const url = this.env.getAutoFieldsEndpoint("/metric");
    return this.$http.post<IMetricPrediction>(url, { title }).then((response) => response.data);
  }

  public sendMetricAnalyticsData(data: IMetricFieldsChoice): IPromise<IMetricFieldsChoice> {
    const url = this.env.getAutoFieldsEndpoint("/metric/feedback");
    return this.$http.post<IMetricFieldsChoice>(url, data).then((response) => response.data);
  }
}
